import ContainerNav from "./Nav/Container"
export default function LayoutPage({ children, childrenClassName, navItems=[] }) {
  return (
    <div className="min-w-0 flex-1 flex flex-col gap-5">
      {Array.isArray(navItems) && navItems.length > 0 && (
        <ContainerNav items={navItems} />
      )}
      <div className={childrenClassName}>
        {children}
      </div>
    </div>
  )
}
